import { Sprite } from 'pixi.js';

import { Shared } from '../../App';
import { CullingComponent } from '../components/CullingComponent';
import { Game } from '../Game';
import { ChunkSpriteData } from '../systems/ChunkSystem';
import { BaseEntity } from './BaseEntity';

export const defaultWarningSignParams = {
    x: 0,
    y: 0,
    z: 0,
    r: 0,
    sx: 1,
    sy: 1,
};

export type WarningSignParams = typeof defaultWarningSignParams;

export class WarningSignEntity extends BaseEntity
{
    public sprite!: Sprite;
    public params!: WarningSignParams;
    public culling: CullingComponent;

    constructor()
    {
        super();
        this.culling = this.addComponent(CullingComponent);
        this.sprite = Sprite.from(Shared.assets.getTexture('warning-sign'));
        this.sprite.anchor.set(0.5, 0.4);
        this.view.addChild(this.sprite);
    }

    public build(params: Partial<WarningSignParams> = {}): void
    {
        this.params = { ...defaultWarningSignParams, ...params };
        this.sprite.scale.x = this.params.sx;
        this.sprite.scale.y = this.params.sy;
        this.rotation = this.params.r;
        this.x = this.params.x;
        this.y = this.params.y;
        this.z = this.params.z;
        this.culling.updateBounds();
    }
}

export class WarningSignFactory
{
    public static match(data: ChunkSpriteData): boolean
    {
        return data.img === 'warning';
    }

    public static create(game: Game, params: Partial<WarningSignParams> = {}): void
    {
        const sign = game.pool.get(WarningSignEntity) as WarningSignEntity;

        sign.build({
            ...params,
            z: -0.3,
            sx: Math.abs(params.sx || 1),
            sy: Math.abs(params.sx || 1),
        });
        game.level.addEntity(sign);
    }
}
